import { render } from "./SpecificationNumber.vue?vue&type=template&id=d8803354"
import script from "./SpecificationNumber.vue?vue&type=script&lang=js"
export * from "./SpecificationNumber.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/bomo-staging/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__